export const FLAG_SPRINT_STARTED = 'state.actions.sprints.start.FLAG_SPRINT_STARTED';

export type ShowSprintStartedFlagAction = {
	type: typeof FLAG_SPRINT_STARTED;
};

export const showSprintStartedFlagAction = (): ShowSprintStartedFlagAction => ({
	type: FLAG_SPRINT_STARTED,
});

export type Action = ShowSprintStartedFlagAction;
